import { Inventory } from "./inventory"
import { BuyingType } from "./buying-type"
import { History } from "./history"

export class AIPlayer {
    public id: number
    public mwatts: number
    public speed: number // 1 to 100
    public buyingType: BuyingType
    public inventory: Inventory
    public history: History
    public cooldown: number
    public timeActed?: number
    constructor(id: number, mwatts: number, speed: number, cooldown: number, buyingType: BuyingType) {
        this.id = id
        this.mwatts = mwatts
        this.speed = speed
        this.cooldown = cooldown
        this.buyingType = buyingType
        this.inventory = new Inventory()
        this.history = new History()
    }
}
